<p class="px-[6px] 3xl:px-2 py-[3px] 3xl:py-1 border text-center text-[8px] 2xl:text-xs 3xl:text-sm font-medium 3xl:font-semibold"
    [ngClass]="[textColor, borderColor, borderRadius]">{{text}}</p>